<template>
  <div v-show="otrasCapas" class="geoproceso-selector-capa">
    <div v-if="isLoadingLayers" class="loading-status">
      <font-awesome-icon icon="spinner" spin /> Cargando capas...
    </div>

    <div class="selector-wrapper">
      <label class="selector-label">Capa de referencia:</label>
      <div class="selector-container">
        <select 
          :value="value"
          @change="onLayerChange"
          class="form-control custom-select"
        >
          <option value="">[Seleccionar una capa]</option>
          <optgroup v-for="(category, index) in filteredCategories" :key="index" :label="category.name">
            <option v-for="layer in category.layers" :key="layer.id" :value="layer.id">
              {{ layer.name }}
            </option>
          </optgroup>
        </select>
      </div>
    </div>

  </div>
</template>

<script>
import { LayerService } from '@/services/layers/layerService';
import { mapService } from '@/services/map/mapService';
import { geoprocessingSelectionHandler } from '@/components/mapTools/geoprocessings/utils/GeoprocessingSelectionHandler';

export default {
  name: 'GeoprocesoSelectorCapa',
  props: {
    value: String,           // ID of the selected layer (capaOtrasSeleccionada)
    otrasCapas: Boolean,
    tipoInfluencia: String,
    distancias: {
      type: Array,
      default: () => []
    },
    dissolve: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      filteredCategories: [],
      isLoadingLayers: false,
    };
  },
  mounted() {
    this.updateLayerFilter();
  },
  beforeDestroy() {
    if (this.value) {
      LayerService.removeLayerByID(this.value);
      geoprocessingSelectionHandler.clearHighlight();
      const map = mapService.get();
      if (map) geoprocessingSelectionHandler.stopSelection(map);
    }
  },
  watch: {
    tipoInfluencia() {
      this.updateLayerFilter();
    },
    otrasCapas(val) {
      if (val) this.updateLayerFilter();
    },
    distancias(newVal) {
      geoprocessingSelectionHandler.updateOptions({ distancias: newVal });
    },
    dissolve(newVal) {
      geoprocessingSelectionHandler.updateOptions({ dissolve: newVal });
    }
  },
  methods: {
    async updateLayerFilter() {
      if (!this.otrasCapas) return;
      this.isLoadingLayers = true;
      try {
        const allCategories = this.$store.getters.getLayers || [];
        this.filteredCategories = await LayerService.filterLayersByInfluence(allCategories, this.tipoInfluencia);
      } finally {
        this.isLoadingLayers = false;
      }
    },
    onLayerChange(event) {
      const layerId = event.target.value;
      const oldLayerId = this.value;

      if (oldLayerId) {
        LayerService.removeLayerByID(oldLayerId);
        geoprocessingSelectionHandler.clearHighlight();
        const map = mapService.get();
        if (map) geoprocessingSelectionHandler.stopSelection(map);
      }

      this.$emit('input', layerId);

      if (!layerId) return;

      let selectedLayer = null;
      for (const cat of this.filteredCategories) {
        const found = cat.layers.find(l => l.id == layerId);
        if (found) {
          selectedLayer = found;
          break;
        }
      }

      if (selectedLayer) {
        LayerService.addLayerToMap(selectedLayer, null, false);
        // Start selection automatically after map update
        this.$nextTick(() => {
          this.onStartDrawing();
        });
      }
    },
    onStartDrawing() {
      if (!this.value) return;

      let selectedLayer = null;
      for (const cat of this.filteredCategories) {
        const found = cat.layers.find(l => l.id == this.value);
        if (found) {
          selectedLayer = found;
          break;
        }
      }

      if (!selectedLayer) return;

      const map = mapService.get();
      if (!map) return;

      // Force accumulation mode (true) as requested
      geoprocessingSelectionHandler.startSelection(
        map,
        selectedLayer,
        this.tipoInfluencia,
        (features, details) => {
          this.$emit('selection-complete', { features, details });
        },
        true, 
        { distancias: this.distancias, dissolve: this.dissolve }
      );
    }
  }
};
</script>

<style scoped>
.geoproceso-selector-capa {
  margin-bottom: 4px;
  padding: 0 5px;
}

.selector-wrapper {
  background: rgba(255, 255, 255, 0.4);
  padding: 6px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.selector-label {
  display: block;
  font-size: 0.8em;
  font-weight: 600;
  color: #444;
  margin-bottom: 3px;
}

.loading-status {
  font-size: 11px;
  color: #666;
  margin-bottom: 3px;
}

.custom-select {
  width: 100%;
  padding: 6px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: white;
  font-size: 0.85em;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.custom-select:focus {
  border-color: #337ab7;
  outline: none;
  box-shadow: 0 0 0 2px rgba(51, 122, 183, 0.1);
}
</style>
